import { Link } from 'gatsby'
import { FC } from 'react'

const ProductPageBanner : FC<{ pageTitle: string, homePageUrl: string, homePageText: string, activePageText: string, product:string}> = ({ pageTitle, homePageUrl, homePageText, activePageText, product}) => {
    return (
        <div className={`page-title-area product ${product}`}>
            <div className="container-fluid hero-container">
                <div className="page-title-content">
                    <h2>{pageTitle}</h2>
                    <ul>
                        <li>
                            <Link to={homePageUrl}>
                                {homePageText}
                            </Link>
                        </li>
                        <li>{activePageText}</li>
                    </ul>
                </div>
            </div>
        </div>
    )
}

export default ProductPageBanner;